import { useFormContext, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { SimpleSelect } from '@calendly/ui/components/select';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Layout } from 'components/layout';
const RescheduleLayout = props => <Layout gap="4" direction="column" {...props} />;
const simpleSelectContainerCss = "s1xfp9ll";
const SimpleSelectContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(simpleSelectContainerCss, props.className)} />;
});
const ReadOnlyReschedulePreference = () => {
  const {
    values: {
      lockRescheduleMembers
    }
  } = useFormContext();
  const reschedulingMessage = lockRescheduleMembers === 'true' ? I18n.t('publisher.event_type_editor.sections.hosts.keep_original') : I18n.t('publisher.event_type_editor.sections.hosts.reassign_host');
  return <RescheduleLayout>
      <LabelText size="large">{I18n.t('publisher.event_type_editor.sections.hosts.rescheduling_preferences')}</LabelText>
      <BodyText>{reschedulingMessage}</BodyText>
    </RescheduleLayout>;
};
export const ReschedulePreference = ({
  disabled,
  isLocked
}) => {
  const [{
    value
  }, _, {
    setValue,
    setTouched
  }] = useFormField({
    name: 'lockRescheduleMembers'
  });
  if (isLocked) {
    return <ReadOnlyReschedulePreference />;
  }
  const onChange = changedValue => {
    setValue(changedValue);
    setTouched();
  };
  const options = [{
    name: I18n.t('publisher.event_type_editor.sections.hosts.reassign_host'),
    value: 'false'
  }, {
    name: I18n.t('publisher.event_type_editor.sections.hosts.keep_original'),
    value: 'true'
  }];
  return <RescheduleLayout data-component="reschedule-preference">
      <LabelText size="large" id="reschedule-label">
        {I18n.t('publisher.event_type_editor.sections.hosts.rescheduling_preferences')}
      </LabelText>
      <SimpleSelectContainer>
        <SimpleSelect aria-labelledby="reschedule-label" onChange={onChange} options={options} value={value} variant="minimal" disabled={disabled} />
      </SimpleSelectContainer>
    </RescheduleLayout>;
};

require("./reschedule_preference.wyw-in-js.css!=!../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./reschedule_preference.js");